<template>
  <div class="stock-line-dn">
    <span v-if="!entries.length" class="grey--text">—</span>
    <div v-for="entry in entries" :key="entry.key" class="stock-line-dn__row">
      <template v-if="entry.note">
        <router-link
          :to="{ name: 'stock-delivery-notes-view', params: { id: entry.note.id } }"
        >
          {{ entry.note.code }}
        </router-link>
        <v-chip x-small :color="statusColor(entry.note.status)" dark class="ml-1">
          {{ statusLabel(entry.note.status) }}
        </v-chip>
      </template>
      <span v-else class="grey--text">{{ $t("STOCK.SALES_ORDERS.UNPLANNED") }}</span>
      <span v-if="showQuantity" class="caption grey--text ml-1">{{ formatQty(entry.quantity) }}</span>
    </div>
  </div>
</template>

<script>
import { formatStockQuantity } from "@/common/stock/stockNumberFormat";

export default {
  name: "StockOrderLineDeliveryStatus",
  props: {
    schedules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    entries() {
      const schedules = this.schedules || [];
      const assigned = schedules.filter((schedule) => schedule.delivery_note && schedule.delivery_note.id);
      if (!assigned.length) {
        return [];
      }

      const rows = assigned.map((schedule, index) => ({
        key: schedule.id || `dn-${schedule.delivery_note.id}-${index}`,
        note: schedule.delivery_note,
        quantity: Number(schedule.quantity || 0),
      }));

      const unassignedQty = schedules
        .filter((schedule) => !(schedule.delivery_note && schedule.delivery_note.id))
        .reduce((sum, schedule) => sum + Number(schedule.quantity || 0), 0);

      if (unassignedQty > 0.0001) {
        rows.push({
          key: "unplanned",
          note: null,
          quantity: unassignedQty,
        });
      }

      return rows;
    },
    showQuantity() {
      return this.entries.length > 1;
    },
  },
  methods: {
    statusColor(status) {
      return {
        draft: "grey",
        confirmed: "primary",
        executed: "success",
        invoiced: "teal",
        cancelled: "error",
      }[status] || "grey";
    },
    statusLabel(status) {
      const key = `STOCK.DELIVERY_NOTES.STATUS_${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    formatQty(value) {
      return formatStockQuantity(value);
    },
  },
};
</script>

<style scoped>
.stock-line-dn__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 1.6;
}
.stock-line-dn__row a {
  text-decoration: none;
  font-weight: 500;
}
.stock-line-dn__row a:hover {
  text-decoration: underline;
}
</style>
